require(94);
var path = require(68);

module.exports = path.Object.assign;
